import { j as e } from "./atoms-v218.js";
import { Wrapper as f, PaymentOptionsSection as c, Divider as V, SavedCardButton as $, CVVContainer as y, CvvInput as S, SaveButton as B } from "./atoms-v21037.js";
import { useState as b } from "react";
import { PaymentButton as T } from "./atoms-v21029.js";
import { useBreakpoints as O } from "./atoms-v251.js";
import { Icon as k } from "./atoms-v217.js";
const D = (h) => {
  var o;
  const [n, u] = b(""), {
    colorTheme: l = "light",
    cvvError: v,
    isLoading: a = !1,
    isUserLoggedIn: x,
    loggedInProps: t,
    paymentButtons: s,
    paymentHeader: j,
    translations: p
  } = h, { current: C } = O(), m = ["small", "medium"].includes(C);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(f, { children: [
    j,
    s && /* @__PURE__ */ e.jsx(c, { children: s.map((r, i) => /* @__PURE__ */ e.jsx(
      T,
      {
        disabled: a,
        size: m ? "small" : "default",
        ...r
      },
      `${r.brand}-${i}`
    )) }),
    x && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      s && /* @__PURE__ */ e.jsx(V, { $colorTheme: l }),
      /* @__PURE__ */ e.jsxs(c, { children: [
        (o = t == null ? void 0 : t.savedCards) == null ? void 0 : o.map((r, i) => {
          var d;
          return /* @__PURE__ */ e.jsx(
            $,
            {
              $colorTheme: l,
              $isSelected: ((d = t == null ? void 0 : t.selectedCard) == null ? void 0 : d.id) === r.id,
              disabled: a,
              size: m ? "small" : "default",
              ...r
            },
            `${r.brand}-${i}`
          );
        }),
        /* @__PURE__ */ e.jsxs(y, { children: [
          /* @__PURE__ */ e.jsx(
            S,
            {
              defaultValue: n,
              disabled: a,
              error: v,
              label: "CVV",
              onChange: (r) => u(r.target.value),
              tooltip: p.cvvTooltip
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              iconOnly: !0,
              disabled: a,
              onClick: () => {
                var r;
                return (r = t == null ? void 0 : t.setCVV) == null ? void 0 : r.call(t, n);
              },
              shape: "square",
              children: /* @__PURE__ */ e.jsx(k, { name: "arrow-right" })
            }
          )
        ] })
      ] })
    ] })
  ] }) });
};
export {
  D as OtherPaymentMethods
};
